import i18next from 'i18next';

interface Factor {
  type: 'positive' | 'negative';
  title: string;
  checklist: string[];
}

const FactorsAffectingPrice = () => {
  const Factors: Factor[] = [
    {
      type: 'positive',
      title: i18next.t('valuation.factors.positive.heading'),
      checklist: i18next.t('valuation.factors.positive.usps', { returnObjects: true }),
    },
    {
      type: 'negative',
      title: i18next.t('valuation.factors.negative.heading'),
      checklist: i18next.t('valuation.factors.negative.usps', { returnObjects: true }),
    },
  ];

  return `
    <section class="waykevaluation-page-section" aria-label="${i18next.t(
      'valuation.factors.label'
    )}">
      ${Factors.map(
        (factor) => `
        <div class="waykevaluation-stack waykevaluation-stack--4">
          <div class="waykevaluation-stack waykevaluation-stack--2">
            <div class="waykevaluation-content">
              <p class="waykevaluation-content__p waykevaluation-text waykevaluation-text--font-medium">${
                factor.title
              }</p>
            </div>
          </div>
          <div class="waykevaluation-stack waykevaluation-stack--2">
            <ul class="waykevaluation-checklist waykevaluation-checklist--trend-${
              factor.type === 'positive' ? 'up' : 'down'
            }">
              ${factor.checklist
                .map((checklist) => `<li class="waykevaluation-checklist__item">${checklist}</li>`)
                .join('')}
            </ul>
          </div>
        </div>
      `
      ).join('')}
    </section>
  `;
};

export default FactorsAffectingPrice;
